// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentMethodView-Label_cls1__v1Iy4","cls2":"PaymentMethodView-Label_cls2__qvl1r PaymentMethodView-Label_cls1__v1Iy4"};